import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from '../../CommonUtils/SweetAlerts';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup';
import { AllowFloats, handlePaste } from '../../CommonUtils/CommonValidations';
import { useSelector } from 'react-redux';
import { GetCollegeType } from '../../Reducers/AffiliationCommonservice';

export default function AffiliationQuestionsSection3() {
    const LandType = useSelector((state) => state?.commonMastersReducer?.CollegeType);

    const AfflQuestion3validation = Yup.object({
        colgProvidePlaygroundFacili: Yup.string().required(ERROR_MSG).nullable(),
        parkingAreaSuppoDocumValidSatisf: Yup.string().required(ERROR_MSG).nullable(),
        colgParkAreaVirtualInspecProcess: Yup.string().required(ERROR_MSG).nullable(),
        colgPlayAreaSuppoDocumValidSatisf: Yup.string().required(ERROR_MSG).nullable(),
        colgPlayAreaVirtualInspecProcess: Yup.string().required(ERROR_MSG).nullable(),
        colgProvAdequeteToil: Yup.string().required(ERROR_MSG).nullable(),
        colgProvSeperateToilMaleFemale: Yup.string().required(ERROR_MSG).nullable(),
        colgToiletDescremen: Yup.string().required(ERROR_MSG).nullable(),
        colgProvLibrArea: Yup.string().required(ERROR_MSG).nullable(),
        colgProvBooksJournals: Yup.string().required(ERROR_MSG).nullable(),
        colgSubmiPhotoLibr: Yup.string().required(ERROR_MSG).nullable(),
        colgLibrDescremen: Yup.string().required(ERROR_MSG).nullable(),
        colgProvExamiBranch: Yup.string().required(ERROR_MSG).nullable(),
        colgDeputedStaffQuali: Yup.string().required(ERROR_MSG).nullable(),
        discreAdmittedIntake: Yup.string().required(ERROR_MSG).nullable(),
        discrimencyDetails: Yup.string().required(ERROR_MSG).nullable(),
        colgParkingArea: Yup.string().required(ERROR_MSG).nullable(),
        qcourses: Yup.array().of(Yup.object().shape({
            colgAdmitInta2025: Yup.string().required(ERROR_MSG).nullable(),
            colgAdmitInta2024: Yup.string().required(ERROR_MSG).nullable(),
            colgAdmitInta2023: Yup.string().required(ERROR_MSG).nullable(),
            colgAdmitInta2022: Yup.string().required(ERROR_MSG).nullable(),
            // colgAdmitInta2021: Yup.string().required(ERROR_MSG).nullable(),
        })),

    })
    const AfflQuestion3Formik = useFormik({
        initialValues: {
            qcourses: [{
                colgAdmitInta2025: "",
                colgAdmitInta2024: "",
                colgAdmitInta2023: "",
                colgAdmitInta2022: "",
                //colgAdmitInta2021: "",
                courseCatId: "",
                courseCode: "",
            }],

            colgParkingArea: "",
            colgProvidePlaygroundFacili: "",
            parkingAreaSuppoDocumValidSatisf: "",
            colgParkAreaVirtualInspecProcess: "",
            colgPlayAreaSuppoDocumValidSatisf: "",
            colgPlayAreaVirtualInspecProcess: "",
            toiletRatio: "",
            colgProvAdequeteToil: "",
            colgProvSeperateToilMaleFemale: "",
            colgToiletDescremen: "",
            colgProvLibrArea: "",
            colgProvBooksJournals: "",
            colgSubmiPhotoLibr: "",
            colgLibrDescremen: "",
            colgProvExamiBranch: "",
            colgDeputedStaffQuali: "",
            discreAdmittedIntake: "",
            discrimencyDetails: ""

        },
        validationSchema: AfflQuestion3validation,
        onSubmit: (values) => {
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = `${config.url.API_URL}saveAffiliationQuestions3details`;
                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === '01') {
                            successAlert2(res?.data?.sdesc);
                            GetQuestiona3Data();
                            GetCourseData();
                        } else {
                            failureAlert("Failed to Submit");
                        }
                    });
                } else {
                    console.log('Submission canceled');
                }
            });

        },
    })


    const [questions3, setquestiona3] = useState([]);
    function GetQuestiona3Data() {
        let url = config.url.API_URL + "getAffiliationQuestions3Details";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setquestiona3(res?.data?.getAffiliationQuestions3Details);

                AfflQuestion3Formik?.setFieldValue(`colgParkingArea`, res?.data?.getAffiliationQuestions3Details[0]?.colg_parking_area);
                AfflQuestion3Formik?.setFieldValue(`colgProvidePlaygroundFacili`, res?.data?.getAffiliationQuestions3Details[0]?.colg_provide_playground_facili);
                AfflQuestion3Formik?.setFieldValue(`parkingAreaSuppoDocumValidSatisf`, res?.data?.getAffiliationQuestions3Details[0]?.parking_area_suppo_docum_valid_satisf);
                AfflQuestion3Formik?.setFieldValue(`colgParkAreaVirtualInspecProcess`, res?.data?.getAffiliationQuestions3Details[0]?.colg_park_area_virtual_inspec_process);
                AfflQuestion3Formik?.setFieldValue(`colgPlayAreaSuppoDocumValidSatisf`, res?.data?.getAffiliationQuestions3Details[0]?.colg_play_area_suppo_docum_valid_satisf);
                AfflQuestion3Formik?.setFieldValue(`colgPlayAreaVirtualInspecProcess`, res?.data?.getAffiliationQuestions3Details[0]?.colg_play_area_virtual_inspec_process);
                AfflQuestion3Formik?.setFieldValue(`colgProvAdequeteToil`, res?.data?.getAffiliationQuestions3Details[0]?.colg_prov_adequete_toil);
                AfflQuestion3Formik?.setFieldValue(`colgProvSeperateToilMaleFemale`, res?.data?.getAffiliationQuestions3Details[0]?.colg_prov_seperate_toil_male_female);
                AfflQuestion3Formik?.setFieldValue(`colgToiletDescremen`, res?.data?.getAffiliationQuestions3Details[0]?.colg_toilet_descremen);
                AfflQuestion3Formik?.setFieldValue(`colgProvLibrArea`, res?.data?.getAffiliationQuestions3Details[0]?.colg_prov_libr_area);
                AfflQuestion3Formik?.setFieldValue(`colgProvBooksJournals`, res?.data?.getAffiliationQuestions3Details[0]?.colg_prov_books_journals);
                AfflQuestion3Formik?.setFieldValue(`colgSubmiPhotoLibr`, res?.data?.getAffiliationQuestions3Details[0]?.colg_submi_photo_libr);
                AfflQuestion3Formik?.setFieldValue(`colgLibrDescremen`, res?.data?.getAffiliationQuestions3Details[0]?.colg_libr_descremen);
                AfflQuestion3Formik?.setFieldValue(`colgProvExamiBranch`, res?.data?.getAffiliationQuestions3Details[0]?.colg_prov_exami_branch);
                AfflQuestion3Formik?.setFieldValue(`colgDeputedStaffQuali`, res?.data?.getAffiliationQuestions3Details[0]?.colg_deputed_staff_quali);
                AfflQuestion3Formik?.setFieldValue(`discreAdmittedIntake`, res?.data?.getAffiliationQuestions3Details[0]?.discre_admitted_intake);
                AfflQuestion3Formik?.setFieldValue(`discrimencyDetails`, res?.data?.getAffiliationQuestions3Details[0]?.discremency_details);


            } else {
                setquestiona3([])

            }
        })
    }
    const [coursedata, setcoursedata] = useState([]);
    function GetCourseData() {
        let url = config.url.API_URL + "getAffiliationQuestions3CoursesDetails";
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setcoursedata(res?.data?.getAffiliationQuestions3CoursesDetails);

                res?.data?.getAffiliationQuestions3CoursesDetails?.forEach((labdata, i) => {
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].courseCatId`, labdata?.course_cat_id);
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].courseCode`, labdata?.course_id);
                    // AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].colgAdmitInta2021`, labdata?.colg_admit_inta_2021);
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].colgAdmitInta2022`, labdata?.colg_admit_inta_2022);
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].colgAdmitInta2023`, labdata?.colg_admit_inta_2023);
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].colgAdmitInta2024`, labdata?.colg_admit_inta_2024);
                    AfflQuestion3Formik?.setFieldValue(`qcourses[${i}].colgAdmitInta2021`, labdata?.colg_admit_inta_2025);
                })

            } else {
                setcoursedata([])

            }
        })
    }
    useEffect(() => {
        GetQuestiona3Data();
        GetCourseData();
        GetCollegeType();

    }, [])

    const SelectField = ({ fieldName, label }) => {
        return (
            <>
                <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2' >
                    <label className='mb-1 field-mandatory'>{label}</label>
                    <Field as='select' name={fieldName} className='form-control'>
                        <option value=''>---select---</option>
                        <option value='1'>Yes</option>
                        <option value='2'>No</option>
                    </Field>

                    <ErrorMessage name={fieldName} component="div" className="text-error" />
                </bie.Col>

            </>
        );
    };
    return (
        <>

            <CommonFormHeading heading="Excess Intake and Academic Performance Details Section - III" />
            <bie.Container fluid className="px-1" >
                <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                    <FormikProvider value={AfflQuestion3Formik}>
                        <bie.Row className="px-2 pt-3 mb-3">
                            <Form onChange={AfflQuestion3Formik.handleChange} onSubmit={AfflQuestion3Formik.handleSubmit} className='affl-form'>
                                {coursedata.length > 0 && (<>
                                    <div className="table-responsive">
                                        <table className="table table-condensed table-bordered table-sm table-responsive affl-table">
                                            <thead>
                                                <tr>

                                                    <th className='cen' style={{ width: "70px" }}> Sl no</th>
                                                    <th> Course Name		</th>
                                                    <th style={{ width: "100px" }} >Combination	</th>
                                                    <th style={{ width: "100px" }}> Has the College has Admitted Intake more than that of Approved Intake(2025-26)	</th>
                                                    <th style={{ width: "100px" }}> Has the College has Admitted Intake more than that of Approved Intake(2024-25)	</th>
                                                    <th style={{ width: "100px" }}> Has the College has Admitted Intake more than that of Approved Intake(2023-24)	</th>
                                                    <th>Has the College has Admitted Intake more than that of Approved Intake(2022-23)</th>
                                                    {/* <th>  Has the College has Admitted Intake more than that of Approved Intake(2021-22)</th> */}
                                                    {/* <th> Has the College has Admitted Intake more than that of Approved Intake(2020-21)	</th> */}
                                                </tr>

                                            </thead>
                                            <tbody>
                                                {coursedata?.map((course, index) => (
                                                    <tr key={index}>
                                                        <td className='cen'>{index + 1}</td>
                                                        <td style={{ width: "25%", textAlign: "left" }}>{course?.course_cat_name}
                                                            <Field type="hidden" name={`qcourses[${index}].courseCatId`} className="form-control" />

                                                        </td>
                                                        <td style={{ width: "20%", textAlign: "left" }}>{course?.course_name}
                                                            <Field type="hidden" name={`qcourses[${index}].courseCode`} className="form-control" />
                                                        </td>


                                                        <td>
                                                            <Field as="select" name={`qcourses[${index}].colgAdmitInta2025`} className="form-control">
                                                                <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                            </Field>
                                                            <ErrorMessage name={`qcourses[${index}].colgAdmitInta2025`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field as="select" name={`qcourses[${index}].colgAdmitInta2024`} className="form-control">
                                                                <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                            </Field>
                                                            <ErrorMessage name={`qcourses[${index}].colgAdmitInta2024`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field as="select" name={`qcourses[${index}].colgAdmitInta2023`} className="form-control">
                                                                <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                            </Field>
                                                            <ErrorMessage name={`qcourses[${index}].colgAdmitInta2023`} component="div" className="text-error" />
                                                        </td>
                                                        <td>
                                                            <Field as="select" name={`qcourses[${index}].colgAdmitInta2022`} className="form-control">
                                                                <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                            </Field>
                                                            <ErrorMessage name={`qcourses[${index}].colgAdmitInta2022`} component="div" className="text-error" />
                                                        </td>
                                                        {/* <td>
                                                            <Field as="select" name={`qcourses[${index}].colgAdmitInta2021`} className="form-control">
                                                                <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                            </Field>
                                                            <ErrorMessage name={`qcourses[${index}].colgAdmitInta2021`} component="div" className="text-error" />
                                                        </td> */}
                                                        {/* <td>
                                                        <Field as="select" name={`qcourses[${index}].colgAdmitInta201920`} className="form-control">
                                                            <option value=''>--SELECT--</option><option value='1'>Yes</option><option value='2'>No</option>
                                                        </Field>
                                                        <ErrorMessage name={`qcourses[${index}].colgAdmitInta201920`} component="div" className="text-error" />
                                                    </td> */}

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </>)}
                                <bie.Row className='px-2 my-3'>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3}>
                                        <label className='mb-1 field-mandatory'>Is there any discrepancy available in the Admitted Intake and Exams Attended Number:</label>
                                        <Field as='select' name="discreAdmittedIntake" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option><option value='2'>No</option>

                                        </Field>
                                        <ErrorMessage name="discreAdmittedIntake" component="div" className="text-error" />

                                    </bie.Col>

                                    {/* <SelectField
                                        fieldName="discreAdmittedIntake"
                                        label="Is there any discrepancy available in the Admitted Intake and Exams Attended Number:"
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention the discrepancies ( if any, Else please enter Not Applicable):</label>
                                        <Field as='textarea' name="discrimencyDetails" className='form-control' maxLength="350" />
                                        <ErrorMessage name="discrimencyDetails" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">Facilities</h1></div>
                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college provided adequate Parking Area</label>
                                        <Field as='select' name="colgParkingArea" className='form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-0'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgParkingArea" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <SelectField
                                        fieldName="colgParkingArea"
                                        label="Has the college provided adequate Parking Area "
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college provided Playground facilities / Indoor Play Area as Per the Norms:</label>
                                        <Field as='select' name="colgProvidePlaygroundFacili" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvidePlaygroundFacili" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <SelectField
                                        fieldName="colgProvidePlaygroundFacili"
                                        label="Has the college provided Playground facilities / Indoor Play Area as Per the Norms: "
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={7} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Is the Parking Area Supporting document submitted by College found Valid and Satisfactory </label>
                                        <Field as='select' name="parkingAreaSuppoDocumValidSatisf" className='form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-0'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="parkingAreaSuppoDocumValidSatisf" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <SelectField
                                        fieldName="parkingAreaSuppoDocumValidSatisf"
                                        label="Is the Parking Area Supporting document submitted by College found Valid and Satisfactory "
                                    /> */}
                                    {/* <SelectField
                                        fieldName="colgParkAreaVirtualInspecProcess"
                                        label=""
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3}>
                                        <label className='mb-1 field-mandatory'>Is the College Parking Area Verified during the Virtual Inspection process</label>
                                        <Field as='select' name="colgParkAreaVirtualInspecProcess" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>

                                        <ErrorMessage name="colgParkAreaVirtualInspecProcess" component="div" className="text-error" />

                                    </bie.Col >
                                    {/* <SelectField
                                        fieldName="colgPlayAreaSuppoDocumValidSatisf"
                                        label="Is the college Playground / Indoor Play Area Supporting document submitted by College found Valid and Satisfactory "
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={8} xl={6} xxl={4}>
                                        <label className='mb-1 field-mandatory'>Is the college Playground / Indoor Play Area Supporting document submitted by College found Valid and Satisfactory </label>
                                        <Field as='select' name="colgPlayAreaSuppoDocumValidSatisf" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgPlayAreaSuppoDocumValidSatisf" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <SelectField
                                        fieldName="colgPlayAreaVirtualInspecProcess"
                                        label="Is the college Playground / Indoor Play AreaVerified during the Virtual Inspection process:"
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={8} xl={5} xxl={5}>
                                        <label className='mb-1 field-mandatory'>Is the college Playground / Indoor Play AreaVerified during the Virtual Inspection process:</label>
                                        <Field as='select' name="colgPlayAreaVirtualInspecProcess" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgPlayAreaVirtualInspecProcess" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">Toilets</h1></div>
                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                        <label className='field-mandatory mb-1'>Toilet: Student Ratio:</label>
                                        <Field type='text' className='form-control mb-2 mt-3 mt-lg-2 mt-xxl-3' disabled value={questions3[0]?.no_toilets ? questions3[0]?.no_toilets : "-"} />
                                    </bie.Col>

                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has college provided adequate Toilets ( As per the Strength)</label>
                                        <Field as='select' name="colgProvAdequeteToil" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvAdequeteToil" component="div" className="text-error" />
                                    </bie.Col>

                                    {/* <SelectField
                                        fieldName="colgProvAdequeteToil"
                                        label="Has college provided adequate Toilets ( As per the Strength) "
                                    /> */}

                                    {/* <SelectField
                                        fieldName="colgProvSeperateToilMaleFemale"
                                        label="Has college provided Separate Toilets for Female Students "
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has college provided Separate Toilets for Female Students </label>
                                        <Field as='select' name="colgProvSeperateToilMaleFemale" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvSeperateToilMaleFemale" component="div" className="text-error" />
                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={7} xl={6} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention deficiencies /discrepancies identified ( if any, Else please enter Not Applicable) :</label>
                                        <Field as='textarea' name="colgToiletDescremen" className='form-control' maxLength={450} />
                                        <ErrorMessage name="colgToiletDescremen" component="div" className="text-error" />
                                    </bie.Col>
                                </bie.Row>
                                <div className="inner-herbpage-service-title-sub"><h1 className="mb-0">Library and Examination Branch:</h1></div>
                                <bie.Row className='px-2 my-3'>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={6} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has college provided Library Area (Carpet Area) as per the Norms of the University </label>
                                        <Field as='select' name="colgProvLibrArea" className='form-control mb-2 mt-xl-3 mt-xxl-0'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvLibrArea" component="div" className="text-error" />
                                    </bie.Col>

                                    {/* <SelectField
                                        fieldName="colgProvLibrArea"
                                        label="Has college provided Library Area (Carpet Area) as per the Norms of the University "
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={6} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college provided all the Books, Journals and E-Journals as per the Norms of the University for all the Courses and Combinations</label>
                                        <Field as='select' name="colgProvBooksJournals" className='form-control mb-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgProvBooksJournals" component="div" className="text-error" />

                                    </bie.Col>

                                    {/* <SelectField
                                        fieldName="colgProvBooksJournals"
                                        label="Has the college provided all the Books, Journals and E-Journals as per the Norms of the University for all the Courses and Combinations"
                                    /> */}
                                    {/* <SelectField
                                        fieldName="colgSubmiPhotoLibr"
                                        label="Has the college submitted Photo of the Library"
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college submitted Photo of the Library</label>
                                        <Field as='select' name="colgSubmiPhotoLibr" className='form-control mb-2 mt-3 mt-xl-0 mt-xxl-3 mt-lg-2'>
                                            <option value=''>---select---</option>
                                            <option value='1'>Yes</option>
                                            <option value='2'>No</option>
                                        </Field>
                                        <ErrorMessage name="colgSubmiPhotoLibr" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Please mention deficiencies /discrepancies identified ( if any)</label>
                                        <Field as='textarea' name="colgLibrDescremen" className='form-control mb-2' maxLength={450} />

                                        <ErrorMessage name="colgLibrDescremen" component="div" className="text-error" />

                                    </bie.Col>
                                    <bie.Col xs={12} sm={12} md={12} lg={6} xl={3} xxl={3} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Area provided for Examination Branch ({LandType})</label>
                                        <Field as='textarea' name="colgProvExamiBranch" className='form-control mb-2 mt-3 mt-xxl-3 mt-xl-0'
                                            onKeyPress={(e) => { AllowFloats(e); }}
                                            onPaste={(e) => handlePaste(e)} />

                                        <ErrorMessage name="colgProvExamiBranch" component="div" className="text-error" />

                                    </bie.Col>
                                    {/* <SelectField
                                        fieldName="colgDeputedStaffQuali"
                                        label="Has the college deputed adequate staff with Qualifications as per the University Affiliation Norms"
                                    /> */}
                                    <bie.Col xs={12} sm={12} md={12} lg={12} xl={6} xxl={4} className='mb-2'>
                                        <label className='mb-1 field-mandatory'>Has the college deputed adequate staff with Qualifications as per the University Affiliation Norms</label>
                                        <Field as='textarea' name="colgDeputedStaffQuali" className='form-control' maxLength={450} />

                                        <ErrorMessage name="colgProvExamiBranch" component="div" className="text-error" />

                                    </bie.Col>
                                </bie.Row>
                                <div className="pt-1 mb-5">
                                    <button type='submit' className='btn btn-success btn-sm float-end rounded mb-2  '>Submit</button>
                                </div>
                            </Form>
                        </bie.Row>
                    </FormikProvider>
                </bie.Container>
            </bie.Container>

        </>
    )
}
